import * as React from 'react'
// libs
import styled from 'styled-components'
import { Helmet } from 'react-helmet-async'
// components
import Hub from './components/Hub'
import CircularProgress from '@mui/material/CircularProgress'
import UpdateReportModal from 'components/Modals/RenameReportModal'
import ConfirmDeleteModal from 'components/Modals/ConfirmDeleteModal'
import MainLayoutContainer from 'containers/MainLayout'
import ReportPermissionsModal from 'components/Modals/ReportPermissionsModal'
import { Container } from '@mui/material'
import { CreateReportButton, RefreshDatasetsButton } from 'components/CTAs/index'
// context
import { DataHubAPIContext } from 'containers/DataHub/layers/API'
// types
import { PowerBiDatasetRefreshStatus } from 'types/graphql'
// utils
import moment from 'moment'

// styled
const Header = styled.div`
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  font-size: 16px;
  margin-top: 20px;
`

const ProgressLoader = styled(CircularProgress)`
  && {
    position: fixed;
    right: 22px;
  }
`

const DataHub: React.FC = () => {
  const { customReports, datasetRefreshedAt, isLoading, isDataLoading, standardReports } =
    React.useContext(DataHubAPIContext)

  const refreshedAt = datasetRefreshedAt.time || moment()

  const refreshStatus =
    !datasetRefreshedAt.status || datasetRefreshedAt.status === PowerBiDatasetRefreshStatus.Unknown
      ? 'In progress'
      : datasetRefreshedAt.status

  return (
    <>
      <Helmet>
        <title>Skefto - the Data Hub</title>
      </Helmet>
      <MainLayoutContainer
        isLoading={isLoading}
        label={'the Data Hub'}
        CTA={
          <>
            <RefreshDatasetsButton />
            <CreateReportButton />
          </>
        }>
        <Container maxWidth={false}>
          <Header>
            <span>{`Dataset Last Updated ${moment(refreshedAt).format(
              'ddd Do MMM [at] h:mmA'
            )} (Status: ${refreshStatus})`}</span>
          </Header>
          {isDataLoading && <ProgressLoader size={20} />}

          <Hub reports={standardReports} standard />
          <Hub reports={customReports} />

          <UpdateReportModal />
          <ConfirmDeleteModal />
          <ReportPermissionsModal />
        </Container>
      </MainLayoutContainer>
    </>
  )
}

export default DataHub
